<div>
  <div class="heading-title">{{ uploadHeader }}</div>
  <div class="heading-desc">
    <span class="download-template-text" [innerHTML]="downloadTemplateDesc"></span>
  </div>
  <div [innerHTML]="uploadSubHeader"></div>
  <span class="position-relative info-wrapper">
    <app-popover-tooltip [popoverText]="dataFileInfoText" class="upload-info"></app-popover-tooltip>
  </span>
  <div class="file-upload-section outline" draggable="true" (drop)="onDrop($event)" (dragover)="onFileDragOver($event)" (dragleave)="onFiledragOver = !onFiledragOver" [ngClass]="{ outline: onFiledragOver }">
    <p class="file-drag-text">{{ dragDropText }}</p>
    <img src="../../../../../assets/img/cloud-up.svg" alt="Cloud Upload" />
    <p class="file-format-text">{{ fileFormatText }}</p>
    <input id="browseFile" type="file" [attr.accept]="acceptedFileTypes" hidden #uploadFile (change)="browseFile($event)" [multiple]="true" />
    <button mat-flat-button class="browse-btn" (click)="uploadFile.click()">Browse</button>
    @for (file of files; track file; let i = $index) {
      <div class="file-name">
        &nbsp;
        <span class="icon-pin attachment-icon"></span>
        {{ file.name }} &nbsp;&nbsp;
        <span class="icon-shape close-icon" (click)="removeFile(i)" tabindex="0" role="button" (keyup.enter)="$event.target.click()"> </span>
      </div>
    }
  </div>
</div>
<div class="text-right content-footer content-footer-enroll content-footer-verify-posting">
  <button mat-flat-button class="mat-secondary mr-4" id="uploadFileCancelBtn" type="button" (click)="onCancel()">Cancel</button>
  <button id="uploadFileUploadBtn" mat-flat-button class="mat-primary mat-flat-button" [disabled]="files.length < 1" (click)="upload()" data-cy="upload">Upload</button>
</div>
